<span class="badge rounded-pill ch-label-pill" [style.background-color]="background" [style.color]="text">
  {{ label?.name }}
</span>
